import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { isMobile$ } from '../../shared/utils/isMobile';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  public baseUrl = environment.baseUrl;
  public socialMedia = [
    { href: 'https://twitter.com/RedebanM', icon: 'twitter.svg' },
    { href: 'https://www.facebook.com/RedebanM', icon: 'facebook.svg' },
    { href: 'https://www.instagram.com/redebanm/', icon: 'instagram.svg' },
    { href: 'https://www.linkedin.com/company/redeban/', icon: 'linkedin.svg' },
    {
      href: 'https://www.youtube.com/user/RBMRedebanMulticolor',
      icon: 'youtube.svg',
    },
  ];
  public isMobileSub!: Subscription;
  public isMobile!: boolean;

  ngOnInit(): void {
    this.isMobileSub = isMobile$.subscribe((resp) => (this.isMobile = resp));
    window.dispatchEvent(new Event('resize'));
  }

  ngOnDestroy(): void {
    this.isMobileSub.unsubscribe();
  }
}
